import type { InternalState } from './_state.type';

/** Internal State. */
export const internalState: InternalState = {
  internal: {
    user: {
      $is: 'guest',
    },
  },
};
